import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import rolesSaga from './sagas';
import reducer from './reducer';

export function Roles({ children }) {
  useInjectSaga({ key: 'roles', saga: rolesSaga });
  useInjectReducer({ key: 'roles', reducer });

  return React.Children.only(children);
}

Roles.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withRoles } from './withRoles';
export default compose(withConnect, memo)(Roles);
